import { constants } from '@config';

module.exports = _.extend({
  initialize: function () {
    this.tool = INKIVE.Tool.getInstance();
    this.editor = this.tool.editor;
    this.canvas = this.editor.canvas;

    this.zoomIncrement = 0.1;
    this.zoomLowLimit = 0.1;
    this.zoomHightLimit = 5;
    this.deltaScale = 1000;
  },

  get: function () {
    return this.canvas.getZoom();
  },

  updateZoomInfoValue: () => {
    const getActualZoom = INKIVE.DesignFacade.canvas.getZoom();
    const zoomWrapper = document.querySelector('.zoom-wrapper .custom');

    if (!zoomWrapper) return;

    zoomWrapper.textContent = parseInt(getActualZoom * 100) + '%';
  },

  set: function (params) {
    params && this.canvas.setZoom(params.zoom);
    this.adaptCanvasScroll();
  },

  fit: function (params) {
    const zoom = this.getFitZoom(params);

    this.canvas.setZoom(this.getForcedZoomLimits(zoom));

    this.adaptCanvasScroll();
  },

  center: function (params) {
    const zoom = this.canvas.getZoom();
    const center = {
      top: params.y * zoom,
      left: params.x * zoom
    };

    const workareaCenter = {
      top: $(this.curConfig.workarea).height() / 2,
      left: $(this.curConfig.workarea).width() / 2
    };

    const $container = $('#ik-editor > .antiscroll-inner');
    $container.scrollTop(center.top - workareaCenter.top);
    $container.scrollLeft(center.left - workareaCenter.left);
  },

  original: function () {
    this.canvas.setZoom(1.0);
    this.adaptCanvasScroll();
  },

  in: function () {
    const fit = this.getFitZoom();
    const zoom = this.canvas.getZoom() + this.zoomIncrement * fit;
    this.canvas.setZoom(this.getForcedZoomLimits(zoom));

    this.adaptCanvasScroll();
    this.updateZoomInfoValue();
  },

  out: function () {
    const fit = this.getFitZoom();
    const zoom = this.canvas.getZoom() - this.zoomIncrement * fit;
    this.canvas.setZoom(this.getForcedZoomLimits(zoom));

    this.adaptCanvasScroll();
    this.updateZoomInfoValue();
  },

  getForcedZoomLimits: function (zoom) {
    this.adaptCanvasScroll();
    if (zoom > this.zoomHightLimit) {
      return this.zoomHightLimit;
    } else if (zoom < this.zoomLowLimit) {
      return this.zoomLowLimit;
    } else {
      return zoom;
    }
  },

  getZoomProportions: function () {
    const wWidth = $(this.curConfig.workarea).width();
    const wHeight = $(this.curConfig.workarea).height();
    const proportionalW = this.canvas.contentW / wWidth;
    const proportionalH = this.canvas.contentH / wHeight;

    return {
      low: proportionalW < proportionalH ? proportionalW : proportionalH,
      hight: proportionalW > proportionalH ? proportionalW : proportionalH,
      avg: (proportionalW + proportionalH) / 2
    };
  },

  getFitZoom: function (params) {
    params = params || {
      width: this.canvas.contentW,
      height: this.canvas.contentH
    };
    const bleed = this.canvas.runExtensions('getBleedValues');

    const wWidth = $(this.curConfig.workarea).width();
    const wHeight = $(this.curConfig.workarea).height();
    let offset = INKIVE.C.IS_MOBILE ? 5 : 120;

    if (constants.printingTypes[INKIVE.Helpers.getPrintGuidelinesProject()]?.img) {
      offset *= 5;
    }

    this.adaptCanvasScroll();

    if (bleed.active || params.bleed) {
      offset += INKIVE.Helpers.convertUnitsToPixels(bleed.left * 2, bleed.units);
    } else if ($('[data-action=order-print]').is('.order-print-shown')) {
      offset += 40;
    }

    const cWidth = parseFloat(params.width) + offset;
    const cHeight = parseFloat(params.height) + offset;

    const wCoof = wWidth / cWidth;
    const hCoof = wHeight / cHeight;
    return wCoof > hCoof ? hCoof : wCoof;
  },

  adaptCanvasScroll: () => {
    // get the work are container and div values (width).
    const editorCanvasSize = document.querySelector('#ik-editor').getBoundingClientRect();
    const workAreaStyle = document.querySelector('#workarea').style;
    // adapt the size of the #workarea before refreshing the zoom.
    workAreaStyle.width = editorCanvasSize.width + 'px';
    workAreaStyle.height = editorCanvasSize.height + 'px';

    // updates the antiscroll
    $('#ik-editor').antiscroll();
  },

  scrollToZoom: function ({ e, delta }) {
    const handler = new INKIVE.GestureScroll(this.canvas);
    const rootSctm = this.canvas.getSvgPanel().querySelector('g#selectorParentGroup').getScreenCTM().inverse();
    const pt = svgedit.math.transformPoint(e.pageX, e.pageY, rootSctm);
    const mouseTarget = this.canvas.getMouseTarget(e, pt);
    const x = e.pageX;
    const y = e.pageY;

    handler.init(x, y, mouseTarget, false, e);

    const fit = this.getFitZoom();
    const zoom = this.canvas.getZoom() + delta / this.deltaScale * fit;

    this.canvas.setZoom(this.getForcedZoomLimits(zoom));

    handler.update(x, y, e);
    this.canvas.setMode('select');
    document.querySelector('#selectorParentGroup').classList.remove('hidden');

    this.canvas.runExtensions('repositionRulers', {});
    this.adaptCanvasScroll();
    this.updateZoomInfoValue();
  }

}, Backbone.Events);
